module.exports = __webpack_public_path__ + "img/pvalue_icon.db803ab0.png";